import React from "react";
import { CustomSection } from "components/MainSectionTemplate/types";

import GenericHubSpotPanel from "HubSpot/GenericHubSpotPanel";
import HubSpotContactModalPicker from "components/Picker/HubSpotContactPicker/HubSpotContactModalPicker";

interface Props {
  hubSpotContactId: number;
  userId: number;
}

const HubSpotContactPanel = (props: Props) => {
  return <GenericHubSpotPanel
    initialHubSpotId={props.hubSpotContactId}
    urlToHubSpotEntity={(id) => `https://app.hubspot.com/contacts/5257648/record/0-1/${id}/`}
    title="HubSpot"
    apiKey="hubspot-contact-section"
    fetch={window.CoreApi.HubSpot.GetContact}
    link={{
      type: "autolink",
      link: (id: number) => window.CoreApi.User.SetHubSpotContactId({ userId: props.userId, hubSpotContactId: id }),
      unlink: () => window.CoreApi.User.SetHubSpotContactId({ userId: props.userId, hubSpotContactId: null }),
    }}
    create={{
      api: () => window.CoreApi.HubSpot.CreateContact({ systemOneUserId: props.userId }),
      createButtonLabel: "Create"
    }}
    renderPicker={onLink =>
      <HubSpotContactModalPicker
        canCreateNew={false}
        nonInPageEditing={{
          onChange: v => onLink(v.id),
          value: null,
          required: false,
          validatorKey: "hubSpotContact",
        }}
      />
    }

    dataFields={hsContact => [
      {
        key: "hsName",
        label: "Name",
        render: () => <div>{hsContact.name.fullName}</div>,
      }, {
        key: "hsEmail",
        label: "Email",
        render: () => <div>{hsContact.email}</div>,
      }, {
        key: "hsLanguuage",
        label: "Language",
        render: () => <div>{hsContact.hsLanguage}</div>,
      }, {
        key: "hsLifecycleStage",
        label: "Lifecycle stage",
        render: () => <div>{hsContact.lifecycleStageLabel}</div>,
      }
    ]}
  />
}

export const hubSpotContactSection = ({ userId, hubSpotContactId }: { userId: number, hubSpotContactId: number }): CustomSection => {
  return {
    key: "hubSpotContactPanel",
    type: "custom",
    render: () => <HubSpotContactPanel key={"hubSpotContactPanel"} userId={userId} hubSpotContactId={hubSpotContactId} />
  }
}